import { OfferDetailsInterfaceState, initialOfferDetailsState } from '../state/offer-details.state';
import { OfferDetailsActions, EOfferDetailsActions } from '../actions/offer-details.actions';

export function offerDetailsReducer(state: OfferDetailsInterfaceState = initialOfferDetailsState, action: OfferDetailsActions): OfferDetailsInterfaceState {
  switch (action.type) {
    case EOfferDetailsActions.GetOfferDetailsSuccess: {
      return { ...state, offerDetails: action.payload };
    }

    default:
      return state;
  }
};
